import { Workflow } from '../workflow'
import { FilterWorkflowComponent } from './common/filtercomponent'
import { DataWarehouseConnection } from '../workflow/connections/index'
import {
  ColumnDataType,
  Provider,
  TableSchema,
  WorkflowCodeType,
  WorkflowComponentParamType,
  WorkflowEnvVars
} from '../types'
import dedent from 'ts-dedent'

class IsNotNull extends FilterWorkflowComponent {
  constructor() {
    super(
      {
        name: 'native.isnotnull',
        group: 'Data Preparation',
        title: 'Is not Null',
        description: `
      This component filters an input table using the presence or absence of null values in a given column.
      `
      },
      [
        {
          name: 'source',
          type: WorkflowComponentParamType.InputTable,
          title: 'Source table'
        },
        {
          name: 'column',
          type: WorkflowComponentParamType.Column,
          title: 'Column',
          parent: 'source',
          dataType: [
            ColumnDataType.String,
            ColumnDataType.Number,
            ColumnDataType.Geography,
            ColumnDataType.Geometry,
            ColumnDataType.Boolean
          ]
        }
      ]
    )
  }

  async _getMatchCode(
    params: Record<string, unknown>,
    envVars: WorkflowEnvVars,
    workflow: Workflow,
    componentName: string,
    connection: DataWarehouseConnection,
    codeType: WorkflowCodeType,
    schema?: TableSchema
  ) {
    if (connection.type === Provider.DatabricksRest) {
      return dedent`SELECT /*+ REPARTITION(40) */
          *
        FROM ${connection.quoteName(params.source as string)}
        WHERE ${params.column} IS NOT NULL`
    } else {
      return dedent`SELECT *
        FROM ${connection.quoteName(params.source as string)}
        WHERE ${params.column} IS NOT NULL`
    }
  }

  async _getUnmatchCode(
    params: Record<string, unknown>,
    matchTablename: string,
    envVars: WorkflowEnvVars,
    workflow: Workflow,
    componentName: string,
    connection: DataWarehouseConnection,
    codeType: WorkflowCodeType,
    schema?: TableSchema
  ) {
    if (connection.type === Provider.DatabricksRest) {
      return dedent`SELECT /*+ REPARTITION(40) */
          *
        FROM ${connection.quoteName(params.source as string)}
        WHERE ${params.column} IS NULL`
    } else {
      return dedent`SELECT *
        FROM ${connection.quoteName(params.source as string)}
        WHERE ${params.column} IS NULL`
    }
  }
  supportedProviders(): Provider[] {
    return [Provider.BigQuery, Provider.Postgres, Provider.Redshift, Provider.Snowflake, Provider.DatabricksRest]
  }
}

export { IsNotNull }
